<template>
  <div>
    <div>
      <div v-if="loading" class="p-6">
        <Loading />
      </div>
      <div class="p-6 text-center text-gray-500 border rounded bg-gray-50" v-else-if="products.meta.total < 1">
        <div>You have no products.</div>
      </div>
      <div v-else>
        <div class="overflow-x-visible overflow-y-auto border rounded h-96">
          <label class="flex items-center px-4 py-2 border-0 border-b cursor-pointer hover:bg-gray-50" v-for="product in products.data" :key="product.id">
            <input 
              type="checkbox"
              :checked="isInArray(product.id)" 
              :name="product.id.toString()" 
              @change="toggleProduct(product)"
              class="mr-4 text-xl form-checkbox">
            <div class="flex items-center space-x-4">
              <div class="flex items-center justify-center flex-none w-12 h-12 overflow-hidden border rounded bg-gray-50">
                <img v-if="product.image" :src="product.image" :alt="product.name" class="object-cover h-full">
                <fa v-else :icon="['far', 'cube']" class="text-lg text-gray-300" />
              </div>
              <div>
                <div class="flex items-center font-semibold">
                  {{ product.name }}
                </div>
                <div class="text-gray-500">
                  <currency :value="product.price" :currency-code="account.currency" :subunits-value="true" />
                </div>
              </div>
            </div>
            <div class="ml-auto text-right">
              <div v-if="product.status === 'active'">
                <badge class="text-green-800 bg-green-100">Active</badge>
              </div>
              <div v-else-if="product.status === 'draft'">
                <badge class="text-cyan-800 bg-cyan-100">Draft</badge>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProductToggle',

  props: {
    parent: {
      type: Object,
      required: true
    }
  },

  async created () {
    await this.getProducts()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      submitting: false,
      loading: true,
      products: {},
      filter: {
        search: ''
      }
    }
  },

  methods: {
    async getProducts () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/products`, {
          params: {
            page: this.$route.query.page || 1,
            sort: this.$route.query.sort || 'created_at',
            dir: this.$route.query.dir || 'desc',
            ...this.filter && { filter: this.filter }
          }
        })
        this.products = data.products
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },

    toggleProduct (product) {
      this.$emit('toggle', product)
    },

    isInArray (id) {
      return this.parent.products.some(product => product.id === id)
    }
  }
}
</script>